import React from "react";
import { Avatar as AntAvatar } from "antd";
import { useSelector } from "react-redux";

const getInitials = (name) => {
    if (!name) return "?";
    const words = name.trim().split(" ");
    return words.length > 1
        ? words[0][0].toUpperCase() + words[1][0].toUpperCase()
        : words[0][0].toUpperCase();
};

const AvatarComp = ({ size = "large" }) => {
    const userInformation = useSelector((state) => state.editor.userInformation);
    const hasImage = userInformation?.image;
    const userInitials = getInitials(userInformation?.name);

    return (
        <AntAvatar
            size={size}
            src={hasImage ? userInformation.image : null}
            style={{
                width:"46px",
                height:"46px",
                backgroundColor: hasImage ? "transparent" : "#CF9FFF",
                color: "white",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18,
                color: "white",
                fontWeight: 600,
            }}
        >
            {!hasImage && userInitials}
        </AntAvatar>
    );
};

export default AvatarComp;
